import { SessionMap } from './session-map.model';

export class Vendor {
    id:number;
    name:string;
    description:string;
    status:string;
    address:string;
    city:string;
    state:string;
    zip:string;
    email:string;
    phone:string;
    facebook:string;
    twitter:string;
    youtube:string;
    website:string;
    logo: string;

    constructor(data){
        this.id = data.id ? data.id : null;
        this.name = data.name ? data.name : null;
        this.status = data.status ? data.status : null;
        this.description = data.description ? data.description : null;
        this.address = data.address ? data.address : null;
        this.city = data.city ? data.city : null;
        this.state = data.state ? data.state : null;
        this.zip = data.zip ? data.zip : null;
        this.email = data.email ? data.email : null;
        this.phone = data.phone ? data.phone : null;
        this.facebook = data.facebook ? `https://www.facebook.com/${data.facebook}` : null;
        this.twitter = data.twitter ? `https://twitter.com/${data.twitter}` : null;
        this.youtube = data.youtube ? `https://www.youtube.com/${data.youtube}` : null;
        this.website = data.website ? data.website : null;
        this.logo = data.logo ? data.logo : null;

        // if ( !data.id ) {
        //     this.name = "name";
        //     this.status = "Inactive";
        //     this.description = "description";
        //     this.address = "address";
        //     this.city = "city";
        //     this.state = "state";
        //     this.zip = "zip";
        //     this.email = "email";
        //     this.phone = "phone";
        //     this.facebook = "facebook";
        //     this.twitter = "twitter";
        //     this.youtube = "youtube";
        // }
    }
}
